import { Component, HostBinding, HostListener, Input, inject } from '@angular/core';
import { CustomSortDirective, SortDirection } from '../custom-sort.directive';

@Component({
    selector: '[custom-sort-header]',
    templateUrl: './custom-sort-header.component.html',
    styleUrls: ['./custom-sort-header.component.scss'],
    standalone: false
})
export class CustomSortHeaderComponent {
  @Input('custom-sort-header') id: string;

  readonly sort = inject(CustomSortDirective);

  recentlyCleared: SortDirection = null;

  get isSorted(): boolean {
    return this.sort.isSorted(this.id);
  }

  @HostBinding('attr.aria-sort')
  get ariaSort(): string {
    if (!this.isSorted) {
      return 'none';
    }

    return this.sort.direction === 'asc' ? 'ascending' : 'descending';
  }

  @HostListener('click')
  toggle(): void {
    const wasSorted = this.isSorted;
    const previousDirection = this.sort.direction;

    this.sort.sort(this.id);

    this.recentlyCleared = wasSorted && !this.isSorted ? previousDirection : null;
  }

  @HostListener('keydown', ['$event'])
  handleKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    this.toggle();
  }

  @HostListener('mouseleave')
  clearRecentlyCleared(): void {
    this.recentlyCleared = null;
  }
}
